<div [formGroup]="parentFormGroup">
    <div class='mat-error' *ngIf="collectErrors() as errors">
        <small class="mat-error" *ngIf="errors.max" >
            <span *ngIf="minValue">La valeur doit être comprise entre {{minValue}} et {{errors.max.max}}</span>
            <span *ngIf="!minValue">La valeur doit être inférieure ou égale à {{errors.max.max}}</span>
        </small>
        <small class="mat-error" *ngIf="errors.min" >
            <span *ngIf="maxValue">La valeur doit être comprise entre {{errors.min.min}} et {{maxValue}}</span>
            <span *ngIf="!maxValue && errors.min.min !== 0">La valeur doit être supérieure ou égale à {{errors.min.min}}</span>
            <span *ngIf="!maxValue && errors.min.min === 0">La valeur doit être positive</span>
        </small>
        <small class="mat-error" *ngIf="numberFormControl.dirty && errors.required" >
            <span>La valeur est obligatoire</span>
        </small>
        <small class="mat-error" *ngIf="errors.pattern" >
            <span>{{invalidNumberLabel}}</span>
        </small>
    </div>
    <div class="input gap-4 align-items-center" style="display: flex;">

        <input matInput
               #input
               [formControl]="numberFormControl"
               inputmode="decimal"
               placeholder="{{placeHolder}}"
               [max]="maxValue"
               (change)="changed($event)"
               (focus)="focussed()"
               (focusin)="focussed()"
               style="text-align: right; border: none; color: rgba(0, 0, 0, 0.87);
               border-bottom: 1px solid rgb(150, 150, 150); background: transparent; width: 100%; padding: 2px;"
               step="1"
               type="number">
        <div style="font-size: 0.7em;">{{unit}}</div>

        <!-- <ion-input #input [formControl]="numberFormControl"
                   [disabled]="disabled"
                   inputmode="decimal"
                   [min]="minValue" [max]="maxValue"
                   (change)="changed($event)"
                   (ionFocus)="focussed()"
                   [placeholder]="placeHolder"
                   style="border-bottom: 2px solid rgb(230, 230, 230);"
                   type="number" ></ion-input>
        <span style="padding-top: 10px; font-size: 0.7em;">{{unit}}</span> -->
    </div>
</div>
